export default  {"VERSION":"\"7ac42eb\"","COMMITHASH":"\"7ac42eb1901f391b0e2136dc6802f6ab2f6d1fb7\"","BRANCH":"\"master\""}


// WEBPACK FOOTER //
// ./src/data/track/gitinfo.ts